import { GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';
import { Get } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const GetGreenroomInvitationsForMeeting = ({
  meeting,
}: {
  meeting: number;
}): Promise<GreenroomInviteUserResponse[]> => {
  return Get({
    host: GREENROOM_HOST,
    path: `/v3/greenroom/invitations/${meeting}`,
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default GetGreenroomInvitationsForMeeting;
